module.exports = __webpack_public_path__ + "img/bingo_ball-63.859ab41a.png";